<template>
  <div id="diy-dialog-pie-echart">
    <!-- 试卷难度分布折线图组 -->
    <div id="pie-echart"></div>
  </div>
</template>

<script>
export default {
  name: "div_dialog_pie-echart",
  props: {
    title: {
      //饼状图标题
      type: String,
      default: "",
    },
    subTitle: {
      // 饼状图小标题
      type: String,
      default: "",
    },
    yAxis: {
      // Y轴
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      data: this.yAxis,
    };
  },
  watch: {
    yAxis() {
      this.data = this.yAxis;
    },
    data(newValue) {
      this.$emit("showYAxis", this.data);
    },
  },
  methods: {
    initChart() {
      console.log(this.yAxis);
      let examChart = this.$echarts.init(document.getElementById("pie-echart"));
      let option = {
        title: {
          text: this.title,
          subtext: this.subTitle,
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: this.subTitle,
            type: "pie",
            radius: "50%",
            data: this.yAxis,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      examChart.setOption(option);
    },
  },
  mounted() {
    this.initChart();
  },
};
</script>

<style lang="less" scoped>
#diy-dialog-pie-echart {
  width: 100%;
  height: 100%;
  #pie-echart {
    width: 100%;
    height: 500px;
  }
}
</style>